import React from 'react';
import { createPortal } from 'react-dom';
import Login from './Login';

const LoginModal = ({ onLogin, onClose }) => {
  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(3px)'
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ position: 'relative', width: '100%', maxWidth: '420px', margin: '0 16px' }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '-12px',
            right: '-12px',
            zIndex: 1,
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            border: 'none',
            background: '#333',
            color: '#fff',
            fontSize: '16px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label="Close"
        >
          ×
        </button>
        <Login onLogin={onLogin} />
      </div>
    </div>,
    document.body
  );
};

export default LoginModal;
